// extracted by mini-css-extract-plugin
export default {"container":"BottomToolbar_container__fhAuZ","compact":"BottomToolbar_compact__Gm6Qw","toolbarItem":"BottomToolbar_toolbarItem__4YW56"};